<script>
  import { getId, addElement, getLayoutComponent } from './builder.js'
  import { onDestroy } from 'svelte'

  export let variant = 'Default'
  export let config = {}

  export let name = null
  export let value = null
  export let id = getId()
  export let placeholder = null
  export let autocomplete = null
  export let disabled = null
  export let readonly = null

  export let format = null
  export let validate = null
  export let label = name || ''
  export let info = false
  export let required = false
  export let loading = false
  export let maxLength

  const elementName = 'TextField'
  const element = addElement(v => {
    value = v
  })
  $: element.init({ value, format, validate, label, info, required, disabled, loading, maxLength })

  export const validateValue = element.validateValue

  onDestroy(element.selfDestroy)
</script>

<svelte:component this={getLayoutComponent(elementName)} let:inputClass {elementName} {variant} {config} {id}>
  {#if variant === 'Password' && !$element.showPassword}
    <input
      bind:value={$element.value}
      type="password"
      {id}
      {name}
      {placeholder}
      {autocomplete}
      {disabled}
      {readonly}
      {maxLength}
      {label}
      on:focus
      on:blur
      on:input
      on:change
      on:keydown
      on:focus={element.onEvent}
      on:blur={element.onEvent}
      on:input={element.onEvent}
      on:change={element.onEvent}
      class={inputClass}
      required={!!required}
      aria-required={!!required}
      aria-invalid={!!$element.error}
      aria-describedby={$element.error ? `${id}-error` : info ? `${id}-description` : null}
    />
  {:else if variant === 'Email'}
    <input
      bind:value={$element.value}
      type="email"
      {id}
      {name}
      {placeholder}
      {autocomplete}
      {disabled}
      {readonly}
      {maxLength}
      on:focus
      on:blur
      on:input
      on:change
      on:select
      on:keydown
      on:focus={element.onEvent}
      on:blur={element.onEvent}
      on:input={element.onEvent}
      on:change={element.onEvent}
      class={inputClass}
      required={!!required}
      aria-required={!!required}
      aria-invalid={!!$element.error}
      aria-describedby={$element.error ? `${id}-error` : info ? `${id}-description` : null}
    />
  {:else if variant === 'Number'}
    <input
      bind:value={$element.value}
      type="number"
      {id}
      {name}
      {placeholder}
      {autocomplete}
      {disabled}
      {readonly}
      {maxLength}
      on:focus
      on:blur
      on:input
      on:change
      on:keydown
      on:focus={element.onEvent}
      on:blur={element.onEvent}
      on:input={element.onEvent}
      on:change={element.onEvent}
      class={inputClass}
      required={!!required}
      aria-required={!!required}
      aria-invalid={!!$element.error}
      aria-describedby={$element.error ? `${id}-error` : info ? `${id}-description` : null}
    />
  {:else if variant === 'Search'}
    <input
      bind:value={$element.value}
      type="search"
      {id}
      {name}
      {placeholder}
      {autocomplete}
      {disabled}
      {readonly}
      {maxLength}
      on:focus
      on:blur
      on:input
      on:change
      on:keydown
      on:focus={element.onEvent}
      on:blur={element.onEvent}
      on:input={element.onEvent}
      on:change={element.onEvent}
      class={inputClass}
      required={!!required}
      aria-required={!!required}
      aria-invalid={!!$element.error}
      aria-describedby={$element.error ? `${id}-error` : info ? `${id}-description` : null}
    />
  {:else if variant === 'Tel'}
    <input
      bind:value={$element.value}
      type="tel"
      {id}
      {name}
      {placeholder}
      {autocomplete}
      {disabled}
      {readonly}
      {maxLength}
      on:focus
      on:blur
      on:input
      on:change
      on:keydown
      on:focus={element.onEvent}
      on:blur={element.onEvent}
      on:input={element.onEvent}
      on:change={element.onEvent}
      on:keydown={element.onEvent}
      class={inputClass}
      required={!!required}
      aria-required={!!required}
      aria-invalid={!!$element.error}
      aria-describedby={$element.error ? `${id}-error` : info ? `${id}-description` : null}
    />
  {:else if variant === 'Url'}
    <input
      bind:value={$element.value}
      type="url"
      {id}
      {name}
      {placeholder}
      {autocomplete}
      {disabled}
      {readonly}
      {maxLength}
      on:focus
      on:blur
      on:input
      on:change
      on:keydown
      on:focus={element.onEvent}
      on:blur={element.onEvent}
      on:input={element.onEvent}
      on:change={element.onEvent}
      class={inputClass}
      required={!!required}
      aria-required={!!required}
      aria-invalid={!!$element.error}
      aria-describedby={$element.error ? `${id}-error` : info ? `${id}-description` : null}
    />
  {:else}
    <input
      bind:value={$element.value}
      type="text"
      {id}
      {name}
      {placeholder}
      {autocomplete}
      {disabled}
      {readonly}
      {maxLength}
      on:focus
      on:blur
      on:input
      on:change
      on:keydown
      on:focus={element.onEvent}
      on:blur={element.onEvent}
      on:input={element.onEvent}
      on:change={element.onEvent}
      class={inputClass}
      required={!!required}
      aria-required={!!required}
      aria-invalid={!!$element.error}
      aria-describedby={$element.error ? `${id}-error` : info ? `${id}-description` : null}
    />
  {/if}
</svelte:component>
